<template>
    <span class="slides-count"> {{ activeSlides }}/{{ totalSlides }} </span>
</template>

<script>
import { INSTRUMENT_TYPE } from '../../../business/const'

const GERI_MIRI_MAX_SLIDES = 6

export default {
    name: 'SlidesCount',
    props: {
        slides: {
            type: Array,
            required: true
        },
        instrumentType: {
            type: String,
            default: INSTRUMENT_TYPE.VITRO
        }
    },
    computed: {
        activeSlides() {
            return this.slides.filter(slide => !!slide).length
        },
        totalSlides() {
            if ([INSTRUMENT_TYPE.GERI, INSTRUMENT_TYPE.MIRI].includes(this.instrumentType))
                return GERI_MIRI_MAX_SLIDES
            return this.slides.length
        }
    }
}
</script>
